import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table table-sm table-hover table-striped table-bordered" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  class: "text-center",
  "data-label": "Data Nascimento"
}
const _hoisted_4 = {
  class: "text-center",
  "data-label": "CPF"
}
const _hoisted_5 = {
  class: "text-center",
  "data-label": "Tipo"
}
const _hoisted_6 = {
  style: {"margin-top":"1rem"},
  class: "margin-t"
}
const _hoisted_7 = {
  key: 0,
  class: "table table-sm table-hover table-striped table-bordered"
}
const _hoisted_8 = {
  class: "text-start",
  "data-label": "Cliente"
}
const _hoisted_9 = {
  class: "text-start",
  "data-label": "Nome"
}
const _hoisted_10 = {
  class: "text-start",
  "data-label": "Tipo"
}
const _hoisted_11 = {
  class: "text-start",
  "data-label": "Dependente"
}
const _hoisted_12 = {
  class: "text-start text-nowrap",
  "data-label": "Erro"
}

import { reactive, watch } from "vue";

import * as service from "@/services/relatoriosService";
import { fdata } from "@/utils/funcoes";

/*Componentes*/
import Cabecalho from "@/components/ReportView/Cabecalho.vue";

interface IProps {
  clientes?: service.RelClienteDTO[],
  filtros?: string
}

interface IItem {
  cpf: string,
  nome: string,
  dataNascimento?: Date,

  clienteId?: number,
  tipo?: string,
  nomeCliente?: string,
  erro: ''
}


export default /*@__PURE__*/_defineComponent({
  __name: 'relSeguro',
  props: {
    clientes: {},
    filtros: {}
  },
  setup(__props: any) {

/*Vue*/
const props = __props;

let controle = reactive({
  clientes: [] as service.RelClienteDTO[],
  itens: [] as IItem[],
  status: "",
  erro: ""
});

watch(() => props.clientes, async (newValue) => {
  controle.clientes = newValue ?? [];
  await processar();
}, { immediate: true });

async function processar() {

  try {

    controle.itens = [] as IItem[];

    controle.clientes.forEach(e => {

      var jaTem = null;

      if (e.cpf != null && e.cpf != undefined) {
        e.cpf = e.cpf?.replace(/\D/g, ""); // Remove caracteres não numéricos do CPF
      }

      if (e.cpf != null && e.cpf != undefined && e.cpf != "") {
        jaTem = controle.itens.find(a => a.cpf == e.cpf);

        if (jaTem != null) {
          console.log("ja tem: " + e.nome + " " + e.cpf);
          return;
        }
      }
      else {
        console.log("Sem cpf: " + e.nome + " " + e.cpf);
      }

      var item = {
        cpf: e.cpf,
        nome: e.nome,
        dataNascimento: e.dataNascimento,

        clienteId: e.clienteId,
        tipo: "Titular",
        erro: ''
      } as unknown as IItem;

      controle.itens.push(item);

      cadastraConjuge(e);

    });

  } catch (error) {
    controle.erro = "erro agrupando";
  }
}


async function cadastraConjuge(cliente: service.RelClienteDTO) {

  try {


      cliente.dependentes.filter(a=> a.parentesco?.toLowerCase() == "conjuge" || a.parentesco?.toLowerCase() == "cônjuge")
      .forEach(dependente => {

        var jaTem = null;

        var item = {
          cpf: dependente.cpf,
          nome: dependente.nome,
          dataNascimento: dependente.dataNascimento,

          clienteId: cliente.clienteId,
          nomeCliente: cliente.nome,
          tipo: dependente.parentesco,
          erro: (!dependente.cpf ? "Sem CPF" : "")
        } as unknown as IItem;

        controle.itens.push(item);
      });

  } catch (error) {
    controle.erro = "erro agrupando";
  }
}

function titulo(item: IItem) {
  if (item.tipo == "Titular") {
    return "Titular";
  }
  else {
    return item.tipo + " de " + item.nomeCliente + " (Cliente: " + item.clienteId + ")";
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Cabecalho, {
      Titulo: 'Relatório de Clientes - Assistência Seguro',
      Filtros: props.filtros
    }, null, 8, ["Filtros"]),
    _createElementVNode("div", null, _toDisplayString(_unref(controle).itens.filter(a=> a.cpf).length) + " Registros", 1),
    _createElementVNode("table", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("thead", { class: "" }, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "text-nowrap" }, "Nome"),
          _createElementVNode("th", { class: "text-center" }, "Data Nascimento"),
          _createElementVNode("th", { class: "text-center" }, "CPF"),
          _createElementVNode("th", { class: "text-center" }, "Tipo")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens.filter(a=> a.cpf), (cliente, idx) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: idx,
            class: _normalizeClass(!cliente.cpf ? 'table-warning' : '')
          }, [
            _createElementVNode("td", {
              class: "text-start",
              "data-label": "Nome",
              title: titulo(cliente)
            }, _toDisplayString(cliente.nome), 9, _hoisted_2),
            _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(fdata)(cliente.dataNascimento)), 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString(cliente.cpf), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(cliente.tipo), 1)
          ], 2))
        }), 128))
      ])
    ]),
    (_unref(controle).itens.filter(a => a.erro != '').length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(controle).itens.filter(a => a.erro != '').length) + " Erros", 1),
          (_unref(controle).itens.filter(a => a.erro != '').length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("thead", { class: "" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-start" }, "Cliente"),
                    _createElementVNode("th", { class: "text-start" }, "Nome"),
                    _createElementVNode("th", { class: "text-start" }, "Dependente"),
                    _createElementVNode("th", { class: "text-start" }, "Parentesco"),
                    _createElementVNode("th", { class: "text-start" }, "Erro")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens.filter(a => a.erro != ''), (cliente, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: idx,
                      class: _normalizeClass(!cliente.cpf ? 'table-warning' : '')
                    }, [
                      _createElementVNode("td", _hoisted_8, _toDisplayString(cliente.clienteId), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(cliente.nomeCliente), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(cliente.tipo), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(cliente.nome), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(cliente.erro), 1)
                    ], 2))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})